import { breakpoints } from 'theme/MuiThemeProvider/breakpoints';
import { customTheme } from 'theme/MuiThemeProvider/theme';

export const styles = {
  wrap: (isSliderCard: boolean, isHorizontalOrientation: boolean, isRestricted: boolean, size: 'small' | 'large') => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    height: '100%',
    padding: '12px 12px 10px 12px',
    borderRadius: '10px',
    background: customTheme.custom.white,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.12)',
    cursor: 'pointer',
    overflow: 'hidden',
    transition: 'all 0.3s ease-out',
    ...(!isRestricted && {
      ':hover': {
        boxShadow: '2px 3px 16px rgba(0, 0, 0, 0.25)',
        transform: 'scale3d(1.01,1.01,1.01)',
      },
    }),
    ...(size === 'large' && {
      height: '404px',
    }),

    ...(isRestricted && {
      cursor: 'not-allowed',
    }),

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      borderRadius: '10px',
      padding: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      height: 'inherit',

      ...(isHorizontalOrientation && {
        flexDirection: 'row',
        gap: '10px',
      }),
    },
  }),
  imgContainer: {
    position: 'relative',
    display: 'flex',
  },
  image: (isVerticalImage: boolean, isHorizontal: boolean) => ({
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: '10px',
    aspectRatio: '1 / 1',
    position: 'relative',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      ...(isVerticalImage && {
        aspectRatio: '140 / 177',
      }),
      ...(isHorizontal && {
        width: '124px',
      }),
    },
  }),
  imageFilter: (isVerticalImage: boolean, isHorizontal: boolean) => ({
    width: 'calc(100% - 24px)',
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: '10px',
    aspectRatio: '1 / 1',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      width: 'calc(100% - 16px)',
      ...(isVerticalImage && {
        aspectRatio: '140 / 177',
      }),
      ...(isHorizontal && {
        width: '124px',
      }),
    },
    position: 'absolute',
    background: customTheme.custom.gray.G100,
    opacity: 0.5,
  }),

  container: {
    position: 'relative',
  },
  organicTag: (isHorizontal: boolean, inStock: boolean) => ({
    display: 'inline-flex',
    padding: '1px 2px 3px 7px',
    justifyContent: 'flex-start',
    alignItems: 'center',

    position: 'absolute',
    backgroundColor: customTheme.custom.organic,
    fontWeight: 600,
    color: customTheme.custom.white,
    right: '12px',
    top: '27px',
    ...(!inStock && { top: '72px' }),
    width: '59px',
    fontSize: '12px',

    textShadow: '0px 1px 8px rgba(0, 0, 0, 0.1)',

    borderRadius: '8px 0px 0px 8px',
    background: customTheme.custom.organic,
    boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.2)',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      right: '8px',
      ...(isHorizontal && {
        left: '71px',
        width: '52px',
        right: 'auto',
      }),
    },
  }),
  outOfStock: (isHorizontal: boolean) => ({
    display: 'inline-flex',
    padding: '4px 8px',
    justifyContent: 'flex-start',
    alignItems: 'center',

    position: 'absolute',
    fontWeight: 600,
    color: customTheme.custom.black,
    right: '12px',
    top: '27px',
    width: '100px',
    fontSize: '14px',

    borderRadius: '8px 0px 0px 8px',
    background: customTheme.custom.gray.G100,
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.2)',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      right: '8px',
      ...(isHorizontal && {
        left: '12px',
        width: '86px',
        right: 'auto',
      }),
    },
  }),
  publicPricingContainer: (isHorizontal: boolean) => ({
    display: 'inline-block',
    padding: '4px 8px',
    alignItems: 'center',

    position: 'absolute',
    fontWeight: 600,
    boxSizing: 'border-box',
    height: '32px',
    left: '0px',
    bottom: `0px`,
    maxWidth: '200px',
    fontSize: '14px',

    borderRadius: '0px 8px 0px 8px',
    background: customTheme.palette.secondary.S80,
    color: customTheme.custom.white,

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      left: '0px',
      right: '0px',
      lineHeight: '0px',
      top: 'inherit',
      bottom: '0px',
      borderRadius: '0px 0px 10px 10px',
      height: 'inherit',
      ...(isHorizontal && {
        left: '0px',
        width: '124px',
        top: `inherit`,
        bottom: '0px',
        padding: '4px 8px',
      }),
    },
  }),
  publicPrice: (isMobileHorizontal: boolean) => ({
    fontSize: '14px',
    ...(isMobileHorizontal && {
      lineHeight: 1.2,
    }),
  }),
  publicPricingUnits: (isThousandSeed: boolean) => ({
    fontSize: '14px',
    minHeight: '6px',
    ...(isThousandSeed && {
      fontSize: '10px',
      lineHeight: '11px',
      display: 'inline-block',
    }),
  }),
  crop: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '18px',
    color: customTheme.palette.primary.P100,
  },
  content: {
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: '1',
  },
  header: {
    minHeight: '34px',
    marginBottom: '6px',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      minHeight: '42px',
      marginBottom: 0,
    },
  },
  variety: (isHorizontal: boolean) => ({
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '17px',
    color: customTheme.custom.black.B100,
    wordBreak: 'break-word',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    marginBottom: '2px',

    overflow: 'hidden',
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      fontSize: '16px',
      lineHeight: '20px',
      marginBottom: '6px',

      ...(isHorizontal && {
        fontSize: '16px',
      }),
    },
  }),
  name: {
    display: 'inline',
    color: customTheme.custom.black.B50,
    wordBreak: 'keep-all',
  },
  tagsWrap: (isHorizontal: boolean) => ({
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      marginBottom: 0,
      minHeight: '28px',

      ...(isHorizontal && {
        marginBottom: '12px',
      }),
    },
  }),
  type: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px',
    fontWeight: 600,
    fontSize: '10px',
    lineHeight: '12px',
    borderRadius: '3px',
    color: customTheme.palette.secondary.S100,
    backgroundColor: customTheme.palette.secondary.S20,

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      padding: '4px',
      fontSize: '12px',
      lineHeight: '10px',
    },
  },
  stock: {
    padding: '6px',
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: '12px',
    color: customTheme.custom.info,
    backgroundColor: customTheme.custom.blue.B50,
    borderRadius: '3px',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      padding: '4px',
      fontSize: '8px',
      lineHeight: '10px',
    },
  },
  stockTitle: {
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: '12px',
    color: customTheme.custom.info,
    backgroundColor: customTheme.custom.blue.B50,
    marginRight: '4px',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      fontSize: '8px',
      lineHeight: '10px',
    },
  },
  quantity: {
    fontSize: '10px',
    lineHeight: '12px',
    color: customTheme.custom.info,
    backgroundColor: customTheme.custom.blue.B50,
    borderRadius: '3px',
    fontWeight: 400,
    padding: 0,
    display: 'inline-block',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      padding: 0,
      fontSize: '8px',
      lineHeight: '10px',
    },
  },
  footer: (isHidden: boolean) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'end',
    gap: '10px',
    height: '24px',
    paddingBottom: '2px',
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      ...(isHidden && {
        display: 'none',
      }),
      gap: '6px',
      height: '26px',
    },
  }),
  company: (isHorizontal: boolean) => ({
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '12px',
    letterSpacing: '0.2px',
    color: customTheme.custom.black.B50,
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      fontSize: '7px',
      lineHeight: '8px',
      WebkitLineClamp: '3',

      ...(isHorizontal && {
        fontSize: '10px',
        lineHeight: '11px',
      }),
    },
  }),
  country: {
    fontWeight: 600,
    color: customTheme.custom.black.B50,
    marginLeft: '3px',
    display: 'inline',
  },
  logo: (isSmall: boolean, isHorizontal: boolean) => ({
    maxWidth: '70px',
    maxHeight: isSmall ? '34px' : '46px',
    position: 'relative',
    bottom: '-4px',
    right: 0,

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      maxHeight: isSmall ? '28px' : '46px',
      maxWidth: '50px',

      ...(isHorizontal && {
        maxWidth: '70px',
        maxHeight: '36px',
      }),
    },
  }),
  draftLabel: {
    position: 'absolute',
    top: '20px',
    left: '20px',
    padding: '6px',
    borderRadius: '3px',
    background: '#E8E8E8',
    color: '#5E6062',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: '12px',
    letterSpacing: '0.2px',
  },
  suppliedFrom: {
    marginTop: '2px',
    display: 'inline-block',
    textAlign: 'right',
    fontSize: '12px',
    fontWeight: 400,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    color: customTheme.palette.primary.main,
  },
  suppliedFromCompany: {
    fontSize: '12px',
    fontWeight: 500,
  },
  saveContainer: (isSmall: boolean, isSliderCard: boolean, imageHeight: number) => ({
    position: 'absolute',
    right: '16px',
    top: `calc(${imageHeight}px - 32px)`,
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      top: '148px',
      right: '8px',
    },
    ...(!isSliderCard && {
      [`@media (max-width: ${breakpoints.tablet}px)`]: {
        top: '8px',
        left: '88px',
      },
    }),
    padding: '6px',
    animation: `${customTheme.animations.grow} 0.1s ease-in-out, ${customTheme.animations.fadeIn} 0.1s ease-in-out`,
  }),
};
